export default {
  kind: {
    level_gauge: {
      versionId: "",
      versionName: "",
    }
  },
  levelGaugeDashboard: {},
  lostData: {},
  levelGauge: {},
  levelGaugeLastUpdatedAt: -1,
  firestoreSubscribeList: [],
  isEnterprise: true,
  enterpriseVesselsWithContainers: [],
  hanasysExpert: [],
  hanasysExpertLastUpdatedAt: -1,
  enterpriseEcoShipItems: [
    {
      name: "コンテナ顧客企業管理",
      path: "addon-eco-ship-container-customer-master",
    },
  ],
  voyageHistoryDetail: {},
  reports: {},
}